import { FlightBookingStatus, FlightInfoKeys } from '@ag-common-lib/lib/models/registration/flight-information.model';
import { dateFromTimestamp } from './date-from-timestamp';

export const normalizeFlightData = flight => {
  return Object.assign({}, flight, {
    [FlightInfoKeys.status]: flight?.[FlightInfoKeys.status] ?? FlightBookingStatus.initial,
    [FlightInfoKeys.dateSent]: dateFromTimestamp(flight?.[FlightInfoKeys.dateSent]),
  });
};
